module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-for-Creators 3.c234dd1d.jpg";